import { defineMessage } from 'services/localization';

export const messages = {
    emptyRequestName: defineMessage('the_approval_subject_has_not_been_specified'),
    exchangeRateTitle: defineMessage('amount_currency_baseamount_basecurrency'),
    draftBadgeText: defineMessage('draft'),
    copiedText: defineMessage('copied'),
    copyTitle: defineMessage('copy_link_of_the_request'),
};
